import React from 'react';
import { useWebSocket } from '../context/WebSocketContext';
import './NotificationToast.css';

const JobProgressIndicator = () => {
  const { activeJobs } = useWebSocket();

  const jobsArray = Array.from(activeJobs.values()).filter(
    job => job.status === 'pending' || job.status === 'processing'
  );

  if (jobsArray.length === 0) return null;

  const getJobTypeName = (type) => {
    const names = {
      batch_extraction: 'Extracting Items',
      try_on: 'Virtual Try-On',
      combine_outfit: 'Creating Outfit'
    };
    return names[type] || type;
  };

  return (
    <div className="job-progress-container">
      <div className="job-progress-header">
        <span className="job-progress-title">Processing Jobs</span>
        <span className="job-progress-count">{jobsArray.length}</span>
      </div>
      
      {jobsArray.map(job => (
        <div key={job.id} className="job-item">
          <div className="job-item-header">
            <span className="job-item-type">{getJobTypeName(job.type)}</span>
            <span className="job-item-status">{job.status}</span>
          </div>
          <div className="job-progress-bar">
            <div 
              className="job-progress-fill" 
              style={{ width: `${job.progress}%` }}
            ></div>
          </div>
          <div className="job-progress-text">
            {job.progress}% complete
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobProgressIndicator;
